import { render, staticRenderFns } from "./SsoTenant.vue?vue&type=template&id=7f25a6d0"
import script from "./SsoTenant.vue?vue&type=script&lang=js"
export * from "./SsoTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports